import React, { PropsWithChildren } from 'react';
import { InfoTip } from '../InfoTip';
import { LiteUser, useInfluencer } from '@client/new/common/LiteUser.mapper';
import { F0, F1, TMap } from '../../../helpers/types';
import { ConfigurableSourceType } from '../integrations';
import Spinner from '../../../../components/Spinner';
import { SourceType } from './useURLBuilderState';

const FakeLink = (p: PropsWithChildren<{ onClick: F0 }>) => (
  <span className="cursor-pointer underline" {...p}>
    {p.children}
  </span>
);

export type InfoGeneralProps = {
  onNavigateToIntegration: (type?: ConfigurableSourceType) => void;
};

const integrationNamesMap: TMap<ConfigurableSourceType, string> = {
  facebook: 'Meta Pixel', //1966960130343053,
  tiktok: 'TikTok Pixel', // 55f59933f2ea98ad46b8555ca68a345401732b22
  google: 'Google Services',
};

const serviceNamesMap: TMap<ConfigurableSourceType, string> = {
  facebook: 'Facebook or Instagram', //1966960130343053,
  tiktok: 'Tiktok', // 55f59933f2ea98ad46b8555ca68a345401732b22
  google: 'Google Services',
};

export const capitalize = (v: string) => v.charAt(0).toUpperCase() + v.slice(1);

export const IntegrationInfoTip = ({
  ...p
}: {
  source: SourceType | undefined;
  creator: LiteUser;
  onNavigateToIntegration: F1<ConfigurableSourceType>;
}) => {
  const asyncCreator = useInfluencer(p.creator.id);
  const source = p.source as ConfigurableSourceType;
  if (!integrationNamesMap[source]) return null;
  if (asyncCreator.type !== 'fetched') return <Spinner />;
  const creator = asyncCreator.value;
  const invalidMap: TMap<ConfigurableSourceType, boolean> = {
    facebook:
      !creator.facebookPixelId || !creator.facebookConversionApiAccessToken,
    tiktok:
      !creator.tikTokConfiguration ||
      !creator.tikTokConfiguration.pixelId ||
      !creator.tikTokConfiguration.apiSecret,
    google:
      !creator.ga4Configuration ||
      !creator.ga4Configuration.measurementId ||
      !creator.ga4Configuration.apiSecret,
  };
  if (!invalidMap[source]) return null;

  return (
    <div className="mt-[1em]">
      <InfoTip>
        {`If you intend to track Paid Ads on ${serviceNamesMap[source]} make sure
      you’ve set up the integration with `}
        <FakeLink onClick={() => p.onNavigateToIntegration(source)}>
          {integrationNamesMap[source]}
        </FakeLink>
      </InfoTip>
    </div>
  );
};
